import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Response } from '../../shared/models/response.model';
import { Parcours } from '../models/parcours.model';
import { CreateParcoursRequest } from '../requests/create-parcours';

@Injectable({
  providedIn: 'root',
})
export class RéférentielMétierParcoursService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/parcours';

  trouverTous(idCartographie: string, idReferentiel?: string) {
    let params = new HttpParams().append('idCartographie', idCartographie);

    if (idReferentiel) {
      params = params.append('idReferentiel', idReferentiel);
    }

    return this.#http.get<Response<Parcours>>(this.BASE_URL, { params });
  }

  trouverParGroupe(idCartographie: string, idGroupe: string) {
    const params = new HttpParams().append('idCartographie', idCartographie).append('idGroupe', idGroupe);

    return this.#http.get<Response<Parcours>>(this.BASE_URL, { params });
  }

  trouverParId(idParcours: string) {
    return this.#http.get<Parcours>(this.BASE_URL + '/' + idParcours);
  }

  créer(data: CreateParcoursRequest) {
    return this.#http.post<Parcours>(this.BASE_URL, data);
  }

  modifier(parcours: Parcours): Observable<string> {
    return this.#http.put<string>(this.BASE_URL + '/' + parcours.id, parcours);
  }

  exportCartographie(idCartographie: string): Observable<Blob> {
    return this.#http.get(this.BASE_URL + '/export', {
      params: { idCartographie },
      responseType: 'blob' as const,
    });
  }

  exportOneParcours(idParcours: string, idCartographie: string): Observable<Blob> {
    return this.#http.get(this.BASE_URL + '/export/' + idParcours, {
      params: { idCartographie },
      responseType: 'blob' as const,
    });
  }
}
